import * as THREE from 'three'
import Experience from '../Experience.js'
import vertex from '../Utils/shaders/text/vertex.glsl'
import fragment from '../Utils/shaders/text/fragment.glsl'
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import { gsap } from 'gsap'

export default class Floor {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.lightBackgroundGLSL = this.experience.world.lightBackgroundGLSL
        this.darkBackgroundGLSL = this.experience.world.darkBackgroundGLSL
        this.lightColorOffGLSL = this.experience.world.lightColorOffGLSL
        this.darkColorOffGLSL = this.experience.world.darkColorOffGLSL

        //Setup
        this.resource = this.resources.items.baseModel
        this.textResource = this.resources.items.Quiche_Sans_Bold

        this.setTexture()
        this.setMesh()

        this.setTextMaterial()
        this.setText()
    }

    setTextMaterial(){

        this.material1 = new THREE.ShaderMaterial({
            uniforms: {
                uTime: {value: 0},
                uStartTimer: {value:  1},
                uMin: {value: new THREE.Vector3() },
                uMax: {value: new THREE.Vector3() },
                uColor: {value: 0},
                uBaseColor : { value: localStorage["theme-preference"] === 'light' ?this.lightColorOffGLSL : this.darkColorOffGLSL},
                uBackgroundColor : {value: localStorage["theme-preference"] === 'light' ?this.lightBackgroundGLSL : this.darkBackgroundGLSL}
            },
            vertexShader: vertex,
            fragmentShader: fragment,
        })

        this.material2 = new THREE.ShaderMaterial({
            uniforms: {
                uTime: {value: 0},
                uStartTimer: {value: 1},
                uMin: {value: new THREE.Vector3() },
                uMax: {value: new THREE.Vector3() },
                uColor: {value: 1},
                uBaseColor : { value: localStorage["theme-preference"] === 'light' ?this.lightColorOffGLSL : this.darkColorOffGLSL},
                uBackgroundColor : {value: localStorage["theme-preference"] === 'light' ?this.lightBackgroundGLSL : this.darkBackgroundGLSL}
            },
            vertexShader: vertex,
            fragmentShader: fragment,
        })
        this.material3 = new THREE.ShaderMaterial({
            uniforms: {
                uTime: {value: 0},
                uStartTimer: {value: 1},
                uMin: {value: new THREE.Vector3() },
                uMax: {value: new THREE.Vector3() },
                uColor: {value: 0},
                uBaseColor : { value: localStorage["theme-preference"] === 'light' ?this.lightColorOffGLSL : this.darkColorOffGLSL},
                uBackgroundColor : {value: localStorage["theme-preference"] === 'light' ?this.lightBackgroundGLSL : this.darkBackgroundGLSL}
            },
            vertexShader: vertex,
            fragmentShader: fragment,
        })

        gsap.to(this.material1.uniforms.uStartTimer, {delay:1.2, duration: 2, value: 0, ease: "power2.inOut"  })
        gsap.to(this.material2.uniforms.uStartTimer, {delay:1.5, duration: 2, value: 0, ease: "power2.inOut"  })
        gsap.to(this.material3.uniforms.uStartTimer, {delay:1.4, duration: 2, value: 0, ease: "power2.inOut"  })
    }

    setText() {
        const text1 = `2 UPPER BLADES - 2 UPPER BLADES - 2 UPPER BLADES - 2 UPPER BLADES -`
        const geometry1 = new TextGeometry( text1, {
            font: this.textResource,
            weight: 'bold',
            size: 1.2,
            height: .01,
            curveSegments: 12,
        } );
        geometry1.center()
        geometry1.computeBoundingBox()
        this.material1.uniforms.uMin.value = geometry1.boundingBox.min
        this.material1.uniforms.uMax.value = geometry1.boundingBox.max

        this.textMesh1 = new THREE.Mesh(geometry1, this.material1 )
        this.textMesh1.position.y = 2.4;
        this.textMesh1.scale.x = -1;
        this.scene.add(this.textMesh1)

        const text2 = `3 BLADES LOADED - 3 BLADES LOADED - 3 BLADES LOADED - 3 BLADES LOADED - `
        const geometry2 = new TextGeometry( text2, {
            font: this.textResource,
            weight: 'bold',
            size: 1.2,
            height: .01,
            curveSegments: 12,
        } );
        geometry2.center()
        geometry2.computeBoundingBox()
        this.material2.uniforms.uMin.value = geometry2.boundingBox.min
        this.material2.uniforms.uMax.value = geometry2.boundingBox.max

        this.textMesh2 = new THREE.Mesh(geometry2, this.material2 )
        this.textMesh2.scale.x = -1;
        this.scene.add(this.textMesh2)

        const text3 = `2 BOTTOM BLADES - 2 BOTTOM BLADES - 2 BOTTOM BLADES - 2 BOTTOM BLADES - `
        const geometry3 = new TextGeometry( text3, {
            font: this.textResource,
            weight: 'bold',
            size: 1.2,
            height: .01,
            curveSegments: 12,
        } );
        geometry3.center()
        geometry3.computeBoundingBox()
        this.material3.uniforms.uMin.value = geometry3.boundingBox.min
        this.material3.uniforms.uMax.value = geometry3.boundingBox.max

        this.textMesh3 = new THREE.Mesh(geometry3, this.material3 )
        this.textMesh3.scale.x = -1;
        this.textMesh3.position.y = -2.4;
        this.scene.add(this.textMesh3)
    }

    setTexture () {
        this.textures = {}

        this.textures.color = this.resources.items.baseColorTexture
        this.textures.color.colorSpace = THREE.SRGBColorSpace

        this.textures.colorDark = this.resources.items.baseColorDarkTexture
        this.textures.colorDark.colorSpace = THREE.SRGBColorSpace
        this.textures.colorDark.flipY = false

        this.textures.normal = this.resources.items.baseNormalTexture
        this.textures.normal.flipY = false

        this.textures.roughness = this.resources.items.baseRoughnessTexture
        this.textures.roughness.flipY = false
    }
    setMesh () {
        this.model = this.resource.scene
        this.model.position.set(0, -2.5, 0)
        this.model.scale.set(3.5, 3.5, 3.5)
        this.model.rotation.y = Math.PI * .1
        this.model.receiveShadow = true
        this.wood = this.model.getObjectByName("Cylinder001")
        this.leaf = this.model.getObjectByName("Plane006")
        this.textures.color.offset.y = .09
        this.textures.colorDark.offset.y = .09

        this.materialWood = new THREE.MeshStandardMaterial({
            map: localStorage["theme-preference"] === 'light' ? this.textures.color : this.textures.colorDark,
            normalMap: this.textures.normal,
            roughnessMap: this.textures.roughness,
            depthTest: true,
            depthWrite: true,
        })

        this.materialLeaf = new THREE.MeshStandardMaterial({
            map: localStorage["theme-preference"] === 'light' ? this.textures.color : this.textures.colorDark,
            normalMap: this.textures.normal,
            roughnessMap: this.textures.roughness,
        })

        // Disk hack shadow
        this.diskGeometry = new THREE.CylinderGeometry(1.9, 1.9, .2, 32)
        this.diskMaterial = new THREE.MeshStandardMaterial({ color: 0x666666, transparent: true, opacity: 0 })
        this.disk = new THREE.Mesh(this.diskGeometry, this.diskMaterial)
        // this.disk.rotation.x = Math.PI * -0.5
        this.disk.position.set(0.04, -2.5, -0.13)
        this.disk.castShadow = true
        this.disk.receiveShadow = true
        this.scene.add(this.disk)

        // Declare uniform outside to modify it in tick function
        this.customUniforms = {
            uTime: { value: 0 }
        }

        this.materialLeaf.onBeforeCompile = (shader) => {

            shader.uniforms.uTime = this.customUniforms.uTime

            shader.vertexShader = shader.vertexShader.replace(
                '#include <common>',
                `
                #include <common>

                uniform float uTime;

                mat2 get2dRotateMatrix(float _angle)
                {
                    return mat2(cos(_angle), - sin(_angle), sin(_angle), cos(_angle));
                }
                `
            )
            shader.vertexShader = shader.vertexShader.replace(
                '#include <begin_vertex>',
                `
                #include <begin_vertex>
                
                float angle = (sin(position.z + uTime)) * 0.07;  
                mat2 rotateMatrix = get2dRotateMatrix(angle); 

                transformed.xy = rotateMatrix * transformed.xy;
                `
            )
        }


        this.wood.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.material = this.materialWood
                child.material.envMap = localStorage["theme-preference"] === 'light' ? this.resources.items.environmentMap : this.resources.items.environmentMapDark
                child.material.envMapIntensity = this.resources.items.envMapIntensity
                child.castShadow = true
                child.receiveShadow = true
            }
        })

        this.leaf.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.material = this.materialLeaf
                child.material.envMap = localStorage["theme-preference"] === 'light' ? this.resources.items.environmentMap : this.resources.items.environmentMapDark
                child.material.envMapIntensity = this.resources.items.envMapIntensity
                child.receiveShadow = true
                child.castShadow = true
            }
        })
        this.scene.add(this.model)
    }

    update () {
        this.customUniforms.uTime.value = this.experience.time.elapsed * 0.001
        this.material1.uniforms.uTime.value = this.experience.time.elapsed * 0.00005
        this.material2.uniforms.uTime.value = this.experience.time.elapsed * 0.00006
        this.material3.uniforms.uTime.value = this.experience.time.elapsed * 0.00004
    }
}